export default "__VITE_ASSET__LQontmHQ__"